import React from 'react';
import { useTranslation } from 'react-i18next';
import { KeyMapKeys } from '@locales/lokalise/keyMap';
import cn from 'classnames';

interface ISeparatorProps {
  title: string;
  className?: string;
  testID?: string;
}

const Separator = ({ title, className, testID = 'formSeparator' }: ISeparatorProps) => {
  const { i18n } = useTranslation();

  return (
    <div className={cn('form__separator', className)} data-test-id={testID}>
      {title && <div className="form__separator-label">{i18n.t(title as KeyMapKeys)}</div>}
    </div>
  );
};

export default Separator;
